// src/app/layout/AppLayout.tsx
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileNavDrawer } from './MobileNavDrawer';

/**
 * Shell for every authenticated screen: Sidebar + Header + a routed
 * content outlet, plus a MobileNavDrawer for < lg. Individual pages
 * (e.g. DashboardPage) own their own padding/scroll — this layout only
 * owns the frame, and now also owns the mobile nav open/close state
 * (local useState, no context/provider needed for something this
 * local to the layout).
 */
export function AppLayout() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const { pathname } = useLocation();
  const isRepresentativeProfile = pathname === '/settings';

  return (
    <div className={`flex min-h-screen w-full max-w-full overflow-x-hidden bg-[var(--vania-colors-background-primary,#0b0f1a)]${isRepresentativeProfile ? ' representative-profile-layout' : ''}`}>
      <Sidebar profileLayout={isRepresentativeProfile} />
      <div className="flex flex-1 flex-col min-w-0">
        <Header onOpenNav={() => setIsMobileNavOpen(true)} />
        <main className={`flex-1 min-w-0 overflow-y-auto p-4 sm:p-6${isRepresentativeProfile ? ' representative-profile-main' : ''}`}>
          <Outlet />
        </main>
      </div>
      <MobileNavDrawer
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
      />
    </div>
  );
}
